import { DataTable } from '../../../../design-system/data-table/data-table';
import { AccountView } from '../../../../types/entity-types';
import { ExternalBankAccount } from './account-mapping-form';
import { CreateAccountSelectOptionValue } from './account-mapping-modal-content';
import { accountMappingTableColumnsDefinition } from './account-mapping-table-column-definition';

export type XeroBankAccountView =
  | {
      type: CreateAccountSelectOptionValue;
      id: CreateAccountSelectOptionValue;
      name: string;
    }
  | ({
      type: 'existing';
    } & ExternalBankAccount);

type AccountMappingTableProps = {
  accounts: AccountView[];
  xeroBankAccounts: XeroBankAccountView[];
  isCreatingXeroAccount: boolean;
  onCreateXeroAccount: (seapointAccountId: string) => Promise<string | undefined>;
};

export const AccountMappingTable = ({
  accounts,
  xeroBankAccounts,
  isCreatingXeroAccount,
  onCreateXeroAccount,
}: AccountMappingTableProps) => {
  return (
    <DataTable
      columns={accountMappingTableColumnsDefinition}
      data={accounts}
      initialSorting={[{ id: 'accountName', desc: false }]}
      meta={{
        xeroBankAccounts,
        onRowPrimaryAction: async (rowId: string) => {
          // Return the created account ID so the field can auto-select it
          return await onCreateXeroAccount(rowId);
        },
        isPrimaryActionLoading: isCreatingXeroAccount,
      }}
    />
  );
};
